import React from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import { Box, createStyles, fade, IconButton, Theme } from '@material-ui/core';
import { ExternalDocument } from "../../core/api/model";
import { makeStyles } from "@material-ui/core/styles";
import CustomIcon from "../../core/custom-icon";

export interface DashboardMeetingsListItemProps {
  document: ExternalDocument;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      paddingBottom: theme.spacing(2),
      '&:not(:first-child)': {
        paddingTop: theme.spacing(2)
      },
      '&:not(:last-child)': {
        borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.1)}`
      }
    },
    actionSlot: {
      '& .MuiIconButton-root': {
        padding: 0,
        marginLeft: theme.spacing(1),

        [theme.breakpoints.up('md')]: {
          marginLeft: theme.spacing(4)
        }
      }
    }
  }),
);

export const DashboardDocumentsListItem = (props: DashboardMeetingsListItemProps) => {
    const classes = useStyles();

    return (
      <Box display='flex'
           flexDirection='row'
           className={classes.listItem}
      >
        <Box flex='1 1 auto'>
          <Box component='p' fontSize='body2.fontSize' my='0'>
            <FormattedMessage id='DashboardDocumentsDownloadedOn' />
            {' '}
            <FormattedDate
              value={props.document.accessDate}
              day="numeric"
              month="numeric"
              year="numeric"
            />
          </Box>
          <Box color='primary.main'
               component='h3'
               fontSize='h4.fontSize'
               mt={1}
               mb={1.75}
          >
            {props.document.metaTitle}
          </Box>
          <Box component='p' mb='0'>
            {props.document.metaDescription}
          </Box>
        </Box>
        <Box display='flex'
             alignItems='flex-end'
             flexDirection='column'
             justifyContent='flex-end'
             className={classes.actionSlot}
        >
          <IconButton aria-label='download'
                      target='_blank'
                      component='a'
                      download
                      color='primary'
                      href={props.document.externalUrl}
          >
            <CustomIcon iconname='download' />
          </IconButton>
        </Box>
      </Box>
  )};
